// Notes the analysis leaves about a category: what the estimator should read, and the model's
// remarks about its own tools («value=null», «record_key», «валидатор»), kept as a technical log.

const TECHNICAL = /валидац|валидатор|value=|record_key|sequence=|next_offset|\bnull\b|\bdetails\b|\bmeasurements\b|\bcontext\b|инструмент принял|контроль передачи|проверка сохранения|переданы (?:оставшиеся|последние)/i;
const RECORD_ID = /\s*(?:\(|,\s*id\s+)[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\)?/g;

/** A note without internal record ids, which mean nothing to the estimator. */
export function cleanNote(note: string): string {
  return note.replace(RECORD_ID, "").trim();
}

export function splitNotes(notes: string[] | undefined): { estimator: string[]; technical: string[] } {
  const estimator: string[] = [], technical: string[] = [];
  for (const note of notes ?? []) (TECHNICAL.test(note) ? technical : estimator).push(cleanNote(note));
  return { estimator, technical };
}
